__turbopack_context__.v({
  "ra-footer-contact": "LMQWhq_ra-footer-contact",
  "ra-footer-contact__portal": "LMQWhq_ra-footer-contact__portal",
  "ra-footer-contact__portal__content": "LMQWhq_ra-footer-contact__portal__content",
  "ra-footer-contact__portal__richtext": "LMQWhq_ra-footer-contact__portal__richtext",
  "ra-footer-contact__portals": "LMQWhq_ra-footer-contact__portals",
});
